<template>
  <div class="tradelog-wrapper">
    <div v-if="!tradeLogs || !tradeLogs.data" class="text-center py-5">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
      <p class="text-muted mt-2">Loading trade logs...</p>
    </div>
    
    <div v-else class="animated fadeIn">
      <div class="d-flex justify-content-end mb-3">
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="showAllTrades" v-model="showAll" @change="fetchData">
          <label class="custom-control-label" for="showAllTrades">Show all trades</label>
        </div>
      </div>

      <!-- Trade Logs Grid -->
      <div class="rounded shadow-sm border" style="min-height: 500px;">
        <TradeRecords 
          :records="tradeLogs.data.data" 
          :server="tradeLogs.data.server"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import TradeRecords from './TradeRecords'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TradeLogView',
    components: {
      TradeRecords
    },
    props: {
      username: { type: String, required: true },
      server: { type: String, required: true }
    },
    computed: mapGetters({
      tradeLogs: 'Tradelogs'
    }),
    data () {
      return {
        showAll: false
      }
    },
    watch: {
      username: 'fetchData',
      server: 'fetchData'
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData() {
        if (this.username && this.server) {
          this.emit('searchTradelog', {
            username: this.username, 
            server: this.server, 
            limit: this.showAll ? -1 : 100
          })
        }
      }
    }
  }
</script>
